export default __webpack_public_path__ + "static/media/gallery-spectrespecs_03.60f16850.jpg";